export default function MySQL_SUBSTRING_INDEX() {
  return (
    <div>
      <h2>MySQL_SUBSTRING_INDEX</h2>    </div>
  );
}